import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { PropertyFilterAccessibility } from '__generated__/api';

export const getAccessibilityInput = (searchCriteria: SearchCriteriaModel): PropertyFilterAccessibility[] | null => {
  if (searchCriteria.accessibility && searchCriteria.accessibility.length > 0) {
    return searchCriteria.accessibility
      .map(amen => {
        const result = PropertyFilterAccessibility[PropertyFilterAccessibility[amen]];

        return result ? result : null;
      })
      .filter(x => x !== null);
  }

  return null;
};
